import React from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function FailedSolutions() {
  const failures = [{
    title: 'Jugos verdes comerciales',
    desc: 'Suelen estar cargados de azúcar o fibras crudas que un intestino irritado no puede procesar.'
  }, {
    title: "Productos 'light'",
    desc: 'Contienen edulcorantes artificiales que fermentan en tu colon, creando gas inmediato.'
  }, {
    title: 'Ejercicio cardiovascular intenso',
    desc: 'Eleva el estrés sistémico, ordenando a tu cuerpo retener más sodio y agua.'
  }, {
    title: "Dietas de 'comer limpio'",
    desc: 'Ignoran los antinutrientes de legumbres y cereales que mantienen tu pared intestinal abierta.'
  }];
  return <section className="bg-[#E8F5E2] py-20 px-4" data-id="element-18">
      <div className="max-w-[720px] mx-auto" data-id="element-19">
        <FadeIn data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-10 text-center" data-id="element-21">
            ¿Por qué lo que has probado no funciona?
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-22">
          {failures.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-23">
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-[#4A7C42]/20 flex items-start gap-4" data-id="element-24">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-25" />
                <div data-id="element-26">
                  <h3 className="text-xl font-bold text-[#1A1A1A] mb-2" data-id="element-27">
                    {item.title}
                  </h3>
                  <p className="text-[#5A5A5A] leading-relaxed" data-id="element-28">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}